import { memo, useContext } from 'react'

import { TtsItemSpeakerFlyoutContext } from '../../contextApi'
import SpeakerTone from 'containers/SubSidebar/shared/Voices/SpeakerTone'

const TtsItemVoiceToneContainer: React.FC = () => {
  const { ttsItemInstruction, handleToneChange } = useContext(
    TtsItemSpeakerFlyoutContext
  )

  return (
    <SpeakerTone
      toneInstruction={ttsItemInstruction}
      setToneInstruction={handleToneChange}
    />
  )
}

export default memo(TtsItemVoiceToneContainer)
